import React from 'react';

const sanatoriumFeatures = [
    {
        id: 1,
        bannerText: 'БЕСПЛАТНО', // Текст для функционального баннера
        title: 'Игровая Комната для Детей', // Новый заголовок
        description: 'Пространство для наших маленьких гостей, где они могут весело провести время под присмотром педагога. Доступно для детей старше 4 лет; малыши до 4 лет посещают с родителями. Находится на втором этаже.', // Новое описание
        imageUrl: '/Assets/Services/DetDom.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 2,
        bannerText: 'БЕСПЛАТНО',
        title: 'Центр Культурных Событий', // Новый заголовок
        description: 'Еженедельно здесь проходят разнообразные мероприятия: от музыкальных вечеров и литературных чтений до творческих мастер-классов и выступлений артистов. Наша афиша всегда насыщена.', // Новое описание
        imageUrl: '/Assets/Services/Culture.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 3,
        bannerText: 'БЕСПЛАТНО',
        title: 'Библиотека Санатория', // Новый заголовок
        description: 'Обширный фонд книг для вашего чтения и отдыха. Более двух тысяч экземпляров.', // Новое описание
        imageUrl: '/Assets/Services/Library.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 4,
        bannerText: 'БЕСПЛАТНО',
        title: 'Комфортабельный Трансфер', // Новый заголовок
        description: 'Организуем вашу поездку с комфортом: встречаем и провожаем на ж/д вокзале Кисловодска. Наши опытные водители гарантируют безопасность.', // Новое описание
        imageUrl: '/Assets/Services/Transfer.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 5,
        bannerText: 'БЕСПЛАТНО',
        title: 'Оздоровительные Прогулки (Терренкур)', // Новый заголовок
        description: 'Специально разработанные маршруты на территории санатория для лечебных пеших прогулок под контролем специалиста по лечебной физкультуре.', // Новое описание
        imageUrl: '/Assets/Services/Terrenkur.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 6,
        bannerText: 'БЕСПЛАТНО',
        title: 'Крытый Бассейн', // Новый заголовок
        description: 'Насладитесь плаванием в нашем закрытом бассейне (20 на 8 метров). Доступ разрешен для детей от 4 лет.', // Новое описание
        imageUrl: '/Assets/Services/Bassein.jpg' // !!! Укажи реальный путь к фото !!!
    },

];


const FoodPage = () => {
    return (
        <div className="food-page-container">
            {/* Заголовок страницы - адаптируем */}
            <header className="page-header">
                <h1>Услуги и Инфраструктура</h1>
            </header>

            {/* Основная секция с карточками */}
            <section className="section">
                {/* Описание секции */}
                <div className="section-description">
                    <p>Исследуйте всё, что наш санаторий предлагает для вашего комфортного пребывания, оздоровления и интересного досуга.</p>
                </div>

                {/* Контейнер для грида карточек */}
                <div className="cards-grid">
                    {/* Маппинг данных о возможностях санатория в карточки */}
                    {sanatoriumFeatures.map(feature => (
                        <div className="info-card" key={feature.id}> {/* key важен для списков в React */}
                            {/* Баннер сверху */}
                            <div className={`card-banner ${feature.bannerText === 'БЕСПЛАТНО' ? 'banner-free' : 'banner-paid'}`}>
                                {feature.bannerText}
                            </div>

                            {/* Фотография */}
                            {feature.imageUrl && <img src={feature.imageUrl} alt={feature.title} className="card-image"/>}

                            {/* Основной контент карточки */}
                            <div className="card-content">
                                <h3 className="card-title">{feature.title}</h3>
                                <p className="card-description">{feature.description}</p>
                                {/* Если есть мета-информация, добавь здесь */}
                                {/* <p className="card-meta">{feature.metaInfo}</p> */}
                            </div>
                        </div>
                    ))}
                </div>

            </section>

            {/* Если нужно другие секции, добавь их здесь */}

        </div>
    );
};

export default FoodPage;